export const baseUrl = 'https://backend.interroutes.com'
export const captchaKey = '6LeXitgoAAAAAMPiIBLKzrwoBwo0F_oZASlBUGs3'
// export const baseUrl = 'http://localhost:3001'
